<template>
  <v-img src="@/assets/logo.png" alt="E-Photo Logo" max-height="60" style="margin: 20px;"></v-img>
  <v-container>
    <v-file-input
      v-if="isAuthenticated && (isadmin == 1)"
      variant="solo-filled"
      v-model="file"
      label="Upload Video"
      @change="uploadVideo"
      show-size
      truncate-length="15"
    ></v-file-input>
    <div v-if="loading" class="loading-overlay">
      <v-progress-linear indeterminate color="primary" class="my-4"></v-progress-linear>
    </div>
    <v-row>
      <v-col cols="12" md="4" v-for="video in videos" :key="video.filename">
        <v-card>
          <v-card-title>{{ getTitle(video.filename) }}</v-card-title>
          <v-card-subtitle>{{ getSubtitle(video.filename) }}</v-card-subtitle>

          <video
            :src="`${server}/uploads/videos/${video.filename}`"
            controls
            class="video-preview"
          ></video>
          
          <v-card-actions  style="justify-content: center;">
            <v-btn v-if="isAuthenticated && (isadmin == 1)" @click="removeVideo(video.filename)" class="delete-button">            
              DELETE
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'VideoUploader',
  props: {
    currentUsername: String,    
  },
  data() {
    return {
      file: null,
      videos: [],
      username: localStorage.getItem('user'),
      server: process.env.VUE_APP_SERVER4,
      loading: false,
      isAuthenticated: !!localStorage.getItem('token'),
      isadmin: localStorage.getItem('isAdmin') || 0,
    };
  },
  methods: {
    async uploadVideo() {
      const token = localStorage.getItem('token');

      const formData = new FormData();
      formData.append('file', this.file);
      this.loading = true;
      try {
        await axios.post(`${this.server}/upload-video`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `${token}`
          },
        });
        //this.addVideoDetails(response.data);
        this.loadVideos();
      } catch (error) {
        console.error('Error uploading video:', error);
      } finally {
        this.loading = false;
      }
    },
    
    async loadVideos() {
      try {
        const response = await axios.get(`${this.server}/videos`);
        this.videos = response.data;
      } catch (error) {
        console.error('Error loading videos:', error);
      }
    },
    async removeVideo(filename) {
      if (confirm('Are you sure you want to delete this video?')) {
        const token = localStorage.getItem('token');
        try {
          await axios.delete(`${this.server}/videos/${filename}`, {
            headers: { Authorization: token },
          });
          this.loadVideos();
        } catch (error) {
          console.error('Error deleting video:', error);
        }
      }
    },
    getTitle(filename) {
      const name = filename.split('.')[0];
      return name.split('_')[0];
    },
    getSubtitle(filename) {
      const name = filename.split('.')[0];
      return name.split('_')[1] || '';
    }
  },
  mounted() {
    this.loadVideos();
  },
};
</script>

<style scoped>
.video-preview {
  width: 100%;
  height: 200px;
  object-fit: cover;
  margin-top: 10px;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  width: 100px;
  margin: auto;
}

.file-details {
  display: flex;
  align-items: center;
  width: 100%;
}

.delete-button {
  background-color: transparent !important;
  box-shadow: none !important;
  min-width: 0 !important;
  padding: 10px !important;
  font-size: 16px !important;
  color: red;
  margin-left: 5px;  
}

.delete-button:hover {
  background-color: white !important;
  box-shadow: none !important;
}
</style>
